module.exports = __webpack_public_path__ + "static/nollVision2-4dff6c51e99f2b845aa975f1117002e6.jpg";